import { Center, Stack, Text, Title } from "@mantine/core";

/** Role missing (403 FORBIDDEN or a client-side role gate). */
export function NotPermitted({ inline }: { inline?: boolean }) {
  return (
    <Center py={inline ? "xl" : 120} data-testid="not-permitted">
      <Stack align="center" gap="xs">
        <Title order={2}>Not permitted</Title>
        <Text c="dimmed">Your role does not allow this. Ask an administrator if you need access.</Text>
      </Stack>
    </Center>
  );
}
